import './src/styles/globals.css'
import '@fontsource/train-one/index.css'
import '@fontsource/sawarabi-gothic/index.css'
import '@fontsource/klee-one/index.css'

const cacheCurrentPage = (serviceWorker) => {
  if (typeof window === `undefined` || !(`serviceWorker` in navigator)) return

  const worker = serviceWorker?.active || navigator.serviceWorker.controller
  worker?.postMessage({
    gatsbyApi: `cachePage`,
    url: window.location.href,
  })
}

export const onServiceWorkerInstalled = ({ serviceWorker }) => {
  cacheCurrentPage(serviceWorker)
}

export const onServiceWorkerActive = ({ serviceWorker }) => {
  cacheCurrentPage(serviceWorker)
}

export const onRouteUpdate = () => {
  cacheCurrentPage()
}
